// extracted by mini-css-extract-plugin
export default {"wrapper":"fIjv3h"};